import { LegalPage } from './LegalPage';

/** Copy lives in content/fallbacks.ts (legal.privacy / legal.privacyMeta) and is
 *  editable from admin → Marketing content → Legal. */
export function Privacy() {
  return <LegalPage kind="privacy" />;
}
